import { render, staticRenderFns } from "./Ensayos.vue?vue&type=template&id=17d2c2d0"
import script from "./Ensayos.vue?vue&type=script&lang=js"
export * from "./Ensayos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports